export default "__VITE_ASSET__i4qC2vdJ__"